import { Component, Fragment } from 'react';
import Router from 'next/router';
import cx from 'classnames';
import {
  calculateSipFutureValue,
  formatRupeeLiteral,
  calculateLumpsumFutureValue,
  sipPoints,
  CDN_CLRSAVE_URL,
  Direction,
} from '../constants';
// import Button from '../components/ui/button';
import Field from '../components/ui/field';
import PieChart from 'react-minimal-pie-chart';
// tslint:disable-next-line:no-submodule-imports
import * as HighCharts from 'highcharts';

import {
  getSipCalculatorGraphData,
  getLumpsumCalculatorGraphData,
} from '../utils/graphUtils';

class SipAmountCalculator extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      timePeriod: 20,
      investmentAmount: props.amount,
      fundTypeRate: 14,
      investmentType: props.investmentType || 'SIP_MF',
      showResult: true,
      sipGraphId: props.sipGraphId || 'sip-chart',
      interestRate: null,
    };
  }

  public componentDidMount() {
    // const { onlySipCalculator } = this.props;
    // if (!onlySipCalculator) {
    //   this.loadChart();
    // }
    this.setInterestRate();
    // this.loadChart();
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { investmentType, amount } = nextProps;
    const prevInvestmentType = this.props.investmentType;
    const prevAmount = this.props.amount;
    if (investmentType !== prevInvestmentType) {
      this.setState(
        {
          investmentType,
        },
        () => {
          this.loadChart();
        }
      );
    }
    if (amount !== prevAmount) {
      this.setState(
        {
          investmentAmount: amount,
        },
        () => {
          this.loadChart();
        }
      );
    }
  }
  private loadChart = () => {
    const {
      timePeriod,
      investmentAmount,
      fundTypeRate,
      investmentType,
      sipGraphId,
      interestRate,
    } = this.state;

    const { onlySipCalculator, amount, isVariant } = this.props;
    const isSip = investmentType === 'SIP_MF';
    const returnRate = onlySipCalculator ? fundTypeRate : interestRate;
    const invAmount = onlySipCalculator ? investmentAmount : amount;
    const calculatorGraphData = isSip
      ? getSipCalculatorGraphData(invAmount, returnRate, isVariant)
      : getLumpsumCalculatorGraphData(invAmount, returnRate, isVariant);
    const graphType = isSip ? 'SIP' : 'Lumpsum';
    this.chart = new HighCharts.Chart(sipGraphId, {
      chart: {
        type: 'spline',
      },
      title: {
        text: `Projected ${graphType} Return`,
      },
      yAxis: {
        title: {
          text: 'Investment Value',
        },
        min: 0,
      },
      xAxis: {
        title: {
          text: 'Year',
        },
        min: 0,
        max: timePeriod,
      },
      tooltip: {
        formatter() {
          return `₹${formatRupeeLiteral(this.y)} in ${this.x} years`;
        },
      },
      series: calculatorGraphData,
    });
  };
  public handlePeriodChange = (e: any) => {
    const { value } = e.target;
    const { showResult } = this.state;

    this.setState(
      {
        timePeriod: value,
      },
      () => {
        if (showResult) {
          this.setInterestRate();
          this.loadChart();
        }
      }
    );
  };

  public setInterestRate = () => {
    const { returns, categoryDetails } = this.props;
    const { timePeriod, fundTypeRate } = this.state;
    const {
      return1yr,
      return2yr,
      return3yr,
      return4yr,
      return5yr,
      return6yr,
      return7yr,
      return8yr,
      return9yr,
      return10yr,
      returnSinceInception,
    } = returns;
    const {
      return1yr: categoryReturn1yr,
      return3yr: categoryReturn3yr,
      return5yr: categoryReturn5yr,
      return10yr: categoryReturn10yr,
    } = categoryDetails;
    let interest;
    switch (true) {
      case Number(timePeriod) === 1:
        interest = return1yr || categoryReturn1yr;
        break;
      case Number(timePeriod) === 2:
        interest = return2yr || return1yr;
        break;
      case Number(timePeriod) === 3:
        interest = return3yr || categoryReturn3yr || return1yr;
        break;
      case Number(timePeriod) === 4:
        interest = return4yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 5:
        interest =
          return5yr ||
          categoryReturn5yr ||
          return3yr ||
          categoryReturn3yr ||
          return1yr;
        break;
      case Number(timePeriod) === 6:
        interest =
          return6yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 7:
        interest =
          return7yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 8:
        interest =
          return8yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 9:
        interest =
          return9yr || return5yr || categoryReturn5yr || return3yr || return1yr;
        break;
      case Number(timePeriod) === 10:
        interest =
          return10yr ||
          categoryReturn10yr ||
          return5yr ||
          return3yr ||
          categoryReturn3yr ||
          return1yr;
        break;
      case Number(timePeriod) > 10:
        interest =
          returnSinceInception ||
          return10yr ||
          categoryReturn10yr ||
          return5yr ||
          categoryReturn5yr;
        break;
      default:
        interest = return5yr || fundTypeRate;
    }
    this.setState({ interestRate: interest }, () => {
      this.loadChart();
    });
  };
  public handleAmountChange = (e: any) => {
    const { value } = e.target;
    const { showResult } = this.state;
    const investmentAmount = parseInt(value.replace('Rs. ', ''), 10) || 0;
    this.setState(
      {
        investmentAmount,
      },
      () => {
        if (showResult) {
          this.loadChart();
        }
      }
    );
  };
  public handleFundTypeChange = (e: any) => {
    const { showResult } = this.state;
    this.setState(
      {
        fundTypeRate: e.target.value,
      },
      () => {
        if (showResult) {
          this.loadChart();
        }
      }
    );
  };
  // public handleCalculate = () => {
  //   this.loadChart();
  //   Router.pushRoute('/save/sip-calculator#result');
  //   this.setState({
  //     showResult: true,
  //   });
  // };
  public calculatePieResult = () => {
    const { timePeriod, investmentAmount, fundTypeRate } = this.state;
    const totalMoneyInvested = timePeriod * 12 * investmentAmount;
    const totalFutureAmount = calculateSipFutureValue(
      investmentAmount,
      timePeriod,
      fundTypeRate
    );
    const pieChartData = [
      {
        title: 'Total money invested',
        value: totalMoneyInvested,
        color: '#7CB5EC',
        key: 'pie1',
      },
      {
        title: 'Total future amount',
        value: totalFutureAmount,
        color: '#1DBB93',
        key: 'pie2',
      },
    ];
    const returnsGain = {
      title: 'Returns Gained',
      value: totalFutureAmount - totalMoneyInvested,
    };
    return (
      <Fragment>
        <h5 className="mobile-only--mt20">
          Break-up of total investment value
        </h5>
        <div className="mt40 large-12 medium-12 small-12 columns">
          <PieChart style={{ maxWidth: '150px' }} data={pieChartData} animate />
        </div>
        <div className="mt40 left large-12 medium-8 small-12 columns">
          <ul>
            {pieChartData.map((item: any) => (
              <li key={item.key}>
                <span
                  style={{
                    background: item.color,
                  }}
                />
                <label>
                  {item.title}:{' '}
                  <b className="font--blue">{formatRupeeLiteral(item.value)}</b>
                </label>
              </li>
            ))}
            <li>
              <label>
                {returnsGain.title}:{' '}
                <b className="font--blue">
                  {formatRupeeLiteral(returnsGain.value)}
                </b>
              </label>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  };
  public getSipCalculatorValues = () => {
    return (
      <Fragment>
        <div className="large-12 desktop-only">
          <div id="result" className="row mt10">
            {sipPoints.map(point => {
              return (
                <div
                  className="columns small-6 medium-3 align-flex-center left mb15"
                  key={point.label}
                >
                  <img
                    className="sip-point"
                    src={`${CDN_CLRSAVE_URL}/${point.icon}`}
                  />
                  <div className="pl10">{point.label}</div>
                </div>
              );
            })}
          </div>
        </div>
        <style jsx>{`
          .sip-list {
            margin-left: 20px;
          }
          .sip-point {
            vertical-align: middle;
            margin-right: 10px;
            height: 25px;
            width: 25px;
          }
        `}</style>
      </Fragment>
    );
  };
  public sipResult = () => {
    const { investmentAmount, timePeriod, interestRate } = this.state;
    const { onlySipCalculator, amount } = this.props;
    const invAmount = onlySipCalculator ? investmentAmount : amount;
    return (
      <div className="p10 center mb20">
        <b className="font--blue">{`₹${formatRupeeLiteral(invAmount)}`}</b>{' '}
        invested monthly becomes <br />
        <b className="text--xlg font--blue">
          ₹{''}
          {formatRupeeLiteral(
            calculateSipFutureValue(invAmount, timePeriod, interestRate)
          )}
        </b>{' '}
        in a period of <b className="font--blue">{` ${timePeriod} years`}</b>
      </div>
    );
  };
  public getResult = () => {
    const {
      timePeriod,
      investmentAmount,
      showResult,
      investmentType,
      sipGraphId,
      interestRate,
    } = this.state;

    const { onlySipCalculator, amount } = this.props;

    const isSip = investmentType === 'SIP_MF';
    const invAmount = onlySipCalculator ? investmentAmount : amount;
    if (onlySipCalculator) {
      return (
        <div
          className={cx('mt40 large-8 medium-12 small-12 columns', {
            ['border-bottom pb60']: showResult,
          })}
        >
          {showResult ? (
            <Fragment>
              <div className="large-4 medium-4 small-12 columns">
                {this.calculatePieResult()}
              </div>
            </Fragment>
          ) : null}
          <div className="mb30 large-8 medium-8 small-12 columns">
            <div id={sipGraphId} style={{ margin: '10px auto' }} />
          </div>
          {this.sipResult()}
        </div>
      );
    }
    return (
      <div className="p10">
        {isSip ? (
          this.sipResult()
        ) : (
          <div className="p10 center mb20">
            <b className="font--blue">{`₹ ${formatRupeeLiteral(invAmount)}`}</b>{' '}
            invested one time becomes <br />
            <b className="text--xlg font--blue">
              ₹{' '}
              {formatRupeeLiteral(
                calculateLumpsumFutureValue(invAmount, timePeriod, interestRate)
              )}
            </b>{' '}
            in a period of{' '}
            <b className="font--blue">{` ${timePeriod} years`}</b>
          </div>
        )}
        <div id={sipGraphId} style={{ margin: '10px auto' }} />
      </div>
    );
  };

  public render() {
    const {
      timePeriod,
      investmentAmount,
      fundTypeRate,
      investmentType,
    } = this.state;
    const {
      onlySipCalculator,
      isVariant,
      onChange,
      onAmountChangeBlur,
    } = this.props;
    const minSliderValue = 6;
    const maxSliderValue = 18;
    const minDurationSliderValue = 1;
    const maxDurationSliderValue = 30;
    return (
      <div>
        <div className="row center">
          {!onlySipCalculator && !isVariant ? (
            <h2 className="p10">Calculate Returns</h2>
          ) : null}
          {onlySipCalculator ? this.getSipCalculatorValues() : null}
        </div>
        <div className="row">
          <div
            className={cx('small-12 left p0', {
              'large-4 mt40': onlySipCalculator,
            })}
          >
            <div
              className={cx('left', {
                'bg-blue border-radius-4 columns px15 pb30 pt30': onlySipCalculator,
              })}
            >
              <div className={cx('paper', { plr20: !onlySipCalculator })}>
                {!isVariant ? (
                  <div>
                    <Field
                      value={
                        !onlySipCalculator
                          ? this.props['amount']
                          : `Rs. ${investmentAmount}`
                      }
                      name="amount"
                      id="investmentAmount"
                      type="text"
                      className={cx('large-12', {
                        'bg-blue-input': onlySipCalculator,
                      })}
                      labelName={
                        investmentType === Direction.SIP
                          ? 'SIP Amount'
                          : 'LumpSum Amount'
                      }
                      onChange={
                        !onlySipCalculator ? onChange : this.handleAmountChange
                      }
                      onBlur={!onlySipCalculator ? onAmountChangeBlur : null}
                    />
                    <div className="columns mb20">
                      <div className="row">
                        <div className="columns large-10 pl0 pr0 small-9">
                          <Field
                            value={timePeriod}
                            name="Investment time"
                            id="durationSlider"
                            type="slider"
                            minSliderValue={minDurationSliderValue}
                            maxSliderValue={maxDurationSliderValue}
                            labelName="Investment Duration(Years)"
                            onChange={this.handlePeriodChange}
                            sliderStep="1"
                            labelStyles={'mb20'}
                          />
                        </div>
                        <div className="columns large-2 pr0 pl0 pt30 small-2">
                          <strong>{timePeriod}</strong>{' '}
                          <span className="text--sm">yrs</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                {onlySipCalculator ? (
                  <div className="columns mb20">
                    <div className="row">
                      <div className="columns large-10 pl0 pr0 small-9">
                        <Field
                          value={fundTypeRate}
                          name="Investment time"
                          id="slider"
                          type="slider"
                          minSliderValue={minSliderValue}
                          maxSliderValue={maxSliderValue}
                          labelName="Expected Annual Returns (%)"
                          onChange={this.handleFundTypeChange}
                          sliderStep="0.5"
                          labelStyles={'mb20'}
                        />
                      </div>
                      <div className="columns large-2 pr0 pl0 pt30 small-2">
                        <strong>{fundTypeRate}</strong> %
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className={cx('center', { mt40: onlySipCalculator })}>
              <button
                className="btn btn-blue-solid hover pl30 pr30"
                onClick={() => Router.pushRoute('/s/sip')}
              >
                VIEW OUR BEST SIP PLANS
              </button>
            </div>
          </div>
          {this.getResult()}
        </div>
      </div>
    );
  }
}

export default SipAmountCalculator;



// WEBPACK FOOTER //
// ./components/sipAmountCalculator.tsx